<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <dropdown :class="['mr-2']" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" v-model="top" :items="dropdownVertical" width="100px" /><!--
          --><dropdown :class="['mr-1']" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" v-model="right" :items="dropdownHorizontal" width="100px" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <container align="center">
          <btn @click="addNewNotification" color="white" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" icon-left="notification-clear-all" :color-lightness="null">{{ $lang.addNewNotification }}</btn>
        </container>
      </flex-col>
    </flex>
    <notification :right="right[0] === 'right'" :top="top[0] === 'top'" :item="notification" />
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageNotification',
  mixins: [
    methods
  ],
  data () {
    return {
      notification: {},
      top: ['top'],
      right: ['right'],
      dropdownVertical: [{
        text: 'Top',
        value: 'top'
      }, {
        text: 'Bottom',
        value: 'bottom'
      }],
      dropdownHorizontal: [{
        text: 'Right',
        value: 'right'
      }, {
        text: 'Left',
        value: 'left'
      }]
    }
  },
  methods: {
    addNewNotification () {
      const type = this.getRandomArrayItem(['info', 'success', 'warning', 'error'])
      const persistent = this.getRandomArrayItem([true, false])
      const icon = this.getRandomArrayItem(['home', 'account', 'airplane', 'language-javascript', 'language-html5', null, null, null])
      const slug = this.getRandomArrayItem(['/ui/alert', '/ui/dialog-box', '/ui/data-table', '/forms/text-field', null, null, null])
      const autoClose = this.getRandomArrayItem([5000, 4000, 3000, 2000, null, null, null, null, null, null, null, null])
      this.notification = {
        type,
        icon,
        autoClose,
        persistent,
        visible: true,
        title: this.$lang.notificationType(this.firstLetterCapital(type)),
        text: this.$lang.notificationText(type, persistent, slug, autoClose),
        click: slug ? () => {
          console.log('click', 'notification', slug)
          this.$router.push({
            path: slug
          })
        } : null
      }
      console.log(JSON.stringify(this.notification))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/notification.vue